<template>
  <notes
    description="General Notes related to this Departure"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    departure: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "departure"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.departure.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
